<template>
    <div class="creators-pc-description" :style="{ 'background-image': `url(${landingSections6.background_url})` }">
        <div class="container">
            <h2 class="creators-pc-description__heading show-mobile" v-html="landingSections6.title"/>
            <div class="row">
                <div class="col-md-6">
                    <div class="creators-pc-description__content">
                        <h2 class="creators-pc-description__heading hidden-mobile">
                            {{ landingSections6.title | stripTags }}
                        </h2>
                        <p class="creators-pc-description__text" v-html="landingSections6.body" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "CreatorsPcDescription",
    computed: {
        ...mapState({
            landingSections6: state => state.StarterPc.pageData.landing_page_sections[6]
        })
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.creators-pc-description {
    background-size: cover;
    padding: 130px 0;

    @media (max-width: 580px) {
        background-size: 210vw;
        padding-top: 230px;
        padding-bottom: 0;
        background-position: top center;

        .row {
            padding-bottom: 50px;
            background: linear-gradient(180deg, #181818 0%, #080808 100%);
        }
    }

    &__content {
        padding-left: 20px;

        @media (max-width: 991px) {
            padding: 0;
        }
    }

    &__heading {
        color: $white;
        font-size: 36px;
        text-align: right;
        text-transform: uppercase;

        @media (min-width: 580px) and (max-width: 991px) {
            text-align: center;
        }

        @media (max-width: 580px) {
            text-align: left;
        }
    }

    &__text {
        color: $white;
        font-size: 20px;
        line-height: 28px;
        text-align: right;
        opacity: .7;

        @media (min-width: 580px) and (max-width: 991px) {
            text-align: center;
        }

        @media (max-width: 580px) {
            text-align: left;
        }
    }

    .show-mobile {
        display: none;

        @media (max-width: 580px) {
            display: block;
        }
    }

    .hidden-mobile {
        @media (max-width: 580px) {
            display: none;
        }
    }
}
</style>
